<template>
  <span v-if="needTrim">
    <v-tooltip bottom>
      <span slot="activator">{{ trimmedText }}</span>
      <span>{{ fullText }}</span>
    </v-tooltip>
  </span>
  <span v-else>
      <span>{{ fullText }}</span>
  </span>
</template>

<script>
import _ from 'lodash'

const DEFAULT_OMISSION = '...'
const DEFAULT_LENGTH = 100

export default {
  name: 'text-tooltip-trimmer',
  props: {
    value: {
      type: String
    },
    length: {
      type: Number
    },
    omission: {
      type: String
    }
  },
  computed: {
    computedLength () {
      return _.get(this, 'length', DEFAULT_LENGTH)
    },
    computedOmission () {
      return _.get(this, 'omission', DEFAULT_OMISSION)
    },
    trimmedText () {
      return _.truncate(this.value, {
        length: this.computedLength,
        omission: this.computedOmission
      })
    },
    fullText () {
      return this.value
    },
    needTrim () {
      if (!this.value) {
        return false
      }

      return this.value.length > this.computedLength
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Ui/TextTooltipTrimmer.vue